import { StyledLoginInput } from '../style';

interface Props {
    placeholder: string;
    type: string;
    value: string;
    setValue: (value: string) => void;
}

function LoginInput({ placeholder, type, value, setValue }: Props) {
    return (
        <StyledLoginInput
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={(e: any) => {
                setValue(e.target.value);
            }}
        />
    );
}

export default LoginInput;
